import { render, staticRenderFns } from "./MovementAnalytics.vue?vue&type=template&id=3cdef8a3&scoped=true"
import script from "./MovementAnalytics.vue?vue&type=script&lang=js"
export * from "./MovementAnalytics.vue?vue&type=script&lang=js"
import style0 from "./MovementAnalytics.vue?vue&type=style&index=0&id=3cdef8a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdef8a3",
  null
  
)

export default component.exports